import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Sidebar from "../Sidebar";
import Header from "../Header";
import SuperadminHome from "../../pages/Superadmin/Home";

const superadminLinks = [
  { to: "/superadmin/home", label: "Home" },
];

export default function SuperadminLayout() {
  return (
    <div className="ae-shell">
      <Sidebar links={superadminLinks} />
      <div className="ae-shell-content">
        <Header />
        <main className="ae-shell-main">
          <Routes>
            <Route path="home" element={<SuperadminHome />} />
            <Route path="*" element={<Navigate to="home" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
